import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import './libs/axios'
import * as Sentry from '@sentry/react';

if (import.meta.env.PROD) {
    Sentry.init({
      dsn: "https://b8815ae3b6e2059e51696ab4fe6487db@o4508652016173056.ingest.us.sentry.io/4508652461490177",
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
      ],
      tracesSampleRate: 1.0,
    //   tracePropagationTargets: ["localhost", /^https:\/\/api\.medmonk\.com/],
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    });
}

ReactDOM.createRoot(document.getElementById('root')).render(
    <Sentry.ErrorBoundary>
        <App/>
    </Sentry.ErrorBoundary>
)
